export default __webpack_public_path__ + "static/media/2-small.b658e50d.png";